import React from 'react'
import { IconProps } from '@/checkout-instore-legacy/components/Commons/Icons/IconProps'

export function DeliveryPackage({
  style,
  color = 'currentColor',
  height = 24,
  width = 24,
}: IconProps) {
  const styleIcon = {
    fill: color,
    verticalAlign: 'middle',
    ...style,
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={styleIcon}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2477 17.2659C20.1597 18.1789 20.1587 19.6559 19.2477 20.5659C18.3347 21.4789 16.8567 21.4779 15.9467 20.5659C15.0347 19.6539 15.0347 18.1759 15.9467 17.2659C16.8587 16.3539 18.3357 16.3539 19.2467 17.2649L19.2477 17.2659ZM18.1867 18.3259C17.8607 17.9999 17.3327 18.0009 17.0067 18.3269C16.6807 18.6519 16.6817 19.1799 17.0077 19.5059C17.3327 19.8319 17.8607 19.8309 18.1867 19.5049C18.5127 19.1799 18.5127 18.6519 18.1867 18.3259Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2312 17.2663C9.1432 18.1783 9.1432 19.6563 8.2312 20.5663C7.3192 21.4793 5.8412 21.4783 4.9302 20.5663C4.0192 19.6543 4.0192 18.1763 4.9312 17.2653C5.8432 16.3553 7.3192 16.3543 8.2312 17.2663ZM7.1712 18.3263C6.84519 18.0003 6.3172 18.0013 5.9912 18.3273C5.66519 18.6523 5.66619 19.1803 5.9922 19.5063C6.31719 19.8323 6.84519 19.8313 7.1712 19.5053C7.4972 19.1803 7.49619 18.6523 7.1712 18.3263Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2471 13.75V4.5C14.2471 4.362 14.1351 4.25 13.9971 4.25H9.99707C9.58307 4.25 9.24707 3.914 9.24707 3.5C9.24707 3.086 9.58307 2.75 9.99707 2.75H13.9971C14.9631 2.75 15.7471 3.534 15.7471 4.5V14.5C15.7471 14.914 15.4111 15.25 14.9971 15.25H1.99707C1.58307 15.25 1.24707 14.914 1.24707 14.5C1.24707 14.086 1.58307 13.75 1.99707 13.75H14.2471Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99707 18.166H2.99707C2.85907 18.166 2.74707 18.054 2.74707 17.916V12.5C2.74707 12.086 2.41107 11.75 1.99707 11.75C1.58307 11.75 1.24707 12.086 1.24707 12.5V17.916C1.24707 18.882 2.03107 19.666 2.99707 19.666H4.99707C5.41107 19.666 5.74707 19.33 5.74707 18.916C5.74707 18.502 5.41107 18.166 4.99707 18.166Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0049 7.25H19.3279C19.4299 7.25 19.5209 7.311 19.5589 7.406C19.5599 7.408 21.1659 11.422 21.1659 11.422C21.2239 11.568 21.2549 11.726 21.2549 11.885V17.833C21.2549 17.971 21.1429 18.083 21.0049 18.083H19.1739C18.7599 18.083 18.4239 18.419 18.4239 18.833C18.4239 19.247 18.7599 19.583 19.1739 19.583H21.0049C21.9709 19.583 22.7549 18.799 22.7549 17.833V11.885C22.7549 11.536 22.6879 11.19 22.5589 10.865L20.9519 6.85C20.6889 6.187 20.0439 5.75 19.3279 5.75H15.0049C14.5909 5.75 14.2549 6.086 14.2549 6.5C14.2549 6.914 14.5909 7.25 15.0049 7.25Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0146 18.1704H8.18457C7.77057 18.1704 7.43457 18.5064 7.43457 18.9204C7.43457 19.3344 7.77057 19.6704 8.18457 19.6704H16.0146C16.4286 19.6704 16.7646 19.3344 16.7646 18.9204C16.7646 18.5064 16.4286 18.1704 16.0146 18.1704Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7549 12.75H22.0049C22.4189 12.75 22.7549 13.086 22.7549 13.5C22.7549 13.914 22.4189 14.25 22.0049 14.25H18.0049C17.5909 14.25 17.2549 13.914 17.2549 13.5V9.5C17.2549 9.086 17.5909 8.75 18.0049 8.75H21.2049C21.6189 8.75 21.9549 9.086 21.9549 9.5C21.9549 9.914 21.6189 10.25 21.2049 10.25H18.7549V12.75Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99707 4.25H6.99707C7.41107 4.25 7.74707 3.914 7.74707 3.5C7.74707 3.086 7.41107 2.75 6.99707 2.75H1.99707C1.58307 2.75 1.24707 3.086 1.24707 3.5C1.24707 3.914 1.58307 4.25 1.99707 4.25Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99707 7.25H4.99707C5.41107 7.25 5.74707 6.914 5.74707 6.5C5.74707 6.086 5.41107 5.75 4.99707 5.75H1.99707C1.58307 5.75 1.24707 6.086 1.24707 6.5C1.24707 6.914 1.58307 7.25 1.99707 7.25Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.99707 8.75H1.99707C1.58307 8.75 1.24707 9.086 1.24707 9.5C1.24707 9.914 1.58307 10.25 1.99707 10.25H2.99707C3.41107 10.25 3.74707 9.914 3.74707 9.5C3.74707 9.086 3.41107 8.75 2.99707 8.75Z"
        fill={color}
      />
    </svg>
  )
}
